export default __webpack_public_path__ + "static/257-acd137be420ff6fd09726829cc640451.gif";